import { MapMarkerPlusOutlineIcon } from './MapMarkerPlusOutlineIcon';

/**
 * author: Michael Irigoyen
 * id C1F80E9D-2408-46FC-9E92-AE61A8D5C650
 * name map-marker-plus-outline
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-marker-plus-outline.svg
 * tags
 * - Geographic Information System 
 * - Navigation 
 */
export const LocationPlusOutlineIcon = MapMarkerPlusOutlineIcon;
export default LocationPlusOutlineIcon